import React from 'react';

import { withTranslation } from 'react-i18next';
import { constants } from '../constants/constants';
import CacheData from '../utils/cacheData';
import {BllinkLogger} from "../utils/bllink_loggers";
import Parent from "../parent";
import 'bootstrap/dist/js/bootstrap.min'; // for the modal pop up

export class PaymentNavBar extends Parent {

    constructor(props) {
        super(props);

        this.selectedClass = 'bg-btn-color'
    }


    getButtonsClasses(selectedTab){

        let visitedTabs = CacheData.fetchCache('visitedTabs') || {};
        let debtButtonClass = '', onGoingClass = '', oneTimeClass = '';
        // todo consider visited tabs
        switch (selectedTab){
            case constants.pages.debtTab:
                debtButtonClass += this.selectedClass
                break;
            case constants.pages.onGoingTab:
                onGoingClass += this.selectedClass
                break;
            case constants.pages.oneTimeTab:
                oneTimeClass += this.selectedClass
                break;
            default:
                break;
        }


        const shouldAddCheckedToDebt = (visitedTabs[constants.pages.debtTab] && !debtButtonClass.includes(this.selectedClass))
        const shouldAddCheckedToOnGoing = (visitedTabs[constants.pages.onGoingTab] && !onGoingClass.includes(this.selectedClass))
        const shouldAddCheckedToOneTime = (visitedTabs[constants.pages.oneTimeTab] && !oneTimeClass.includes(this.selectedClass))
        if (shouldAddCheckedToDebt){
            debtButtonClass += ' new_check_sec-2'
        }
        
        if (shouldAddCheckedToOnGoing){
            // class for one time button that adds on the previous button (which is on going)
            onGoingClass += ' new_check_sec-2'
        }

        if (shouldAddCheckedToOneTime){
            oneTimeClass += ' new_check_sec-2'
        }

        return {
            debtButtonClass: debtButtonClass,
            onGoingClass: onGoingClass,
            oneTimeClass: oneTimeClass,
        }
    }

    componentDidMount() {
        BllinkLogger.info(`componentDidMount payment Section`)
        if (this.props.isViewedAsManager){
            // this.managerRelatedBinds(this)
        }else{
            BllinkLogger.info(`not viewed as manager`)
        }

    }

    renderDebt(classes, buildingID, apartmentNumber, paymentsStats){
        const {t} = this.props;
        if (paymentsStats.debtIsEmpty){
            return
        }

        return (
            <li className={classes.debtButtonClass}>
                <a value={constants.pages.debtTab} href={constants.pages.paymentSelectionTab(buildingID, apartmentNumber, constants.pages.debtTab)}>
                    {t('payments.pay_debt')}
                </a>
            </li>
        )
    }

    renderOnGoing(classes, buildingID, apartmentNumber, paymentsStats){
        const {t} = this.props;
        if (paymentsStats.monthlyIsEmpty){
            return
        }

        return (
            <li className={classes.onGoingClass}>
                <a value={constants.pages.onGoingTab} href={constants.pages.paymentSelectionTab(buildingID, apartmentNumber, constants.pages.onGoingTab)}>
                    {t('payments.pay_on_going')}
                </a>
            </li>
        )
    }


    renderOneTime(classes, buildingID, apartmentNumber, paymentsStats){
        const {t} = this.props;
        if (paymentsStats.oneTimeIsEmpty){
            return
        }

        return (
            <li className={classes.oneTimeClass}>
                <a value={constants.pages.oneTimeTab} href={constants.pages.paymentSelectionTab(buildingID, apartmentNumber, constants.pages.oneTimeTab)}>
                    {t('payments.pay_one_time')}
                </a>
            </li>
        )
    }

    render() {

        BllinkLogger.info(`render payment Section`)

        const buildingID = this.props.buildingID;
        const apartmentNumber = this.props.apartmentNumber;
        const classes = this.getButtonsClasses(this.props.paymentTabSelected);
        BllinkLogger.info(` payment section props `, this.props);

        // const isNoActivePayments = (this.props.paymentsStats && this.props.paymentsStats.nonEmptyPayments === 0);
        const hasLessThanTwoPaymentTabs = (this.props.paymentsStats && this.props.paymentsStats.nonEmptyPayments <= 1);
        if (hasLessThanTwoPaymentTabs){
            return <div/>
        }

        if (!this.props.finishedLoadDataFromBackend){
            return <div/>
        }

        return (
            <div className="buttons-sec col-md-12 js-payments-tab ">
                <ul>
                    {this.renderDebt(classes, buildingID, apartmentNumber, this.props.paymentsStats)}
                    {this.renderOnGoing(classes, buildingID, apartmentNumber, this.props.paymentsStats)}
                    {this.renderOneTime(classes, buildingID, apartmentNumber, this.props.paymentsStats)}
                </ul>
            </div>
        )

    }
}


export default withTranslation()(PaymentNavBar);
